import React, {forwardRef, useContext, useImperativeHandle} from 'react';
import {Dialog} from '@priority-software/priority-style-react';
import {ModalTypes} from './enums';
import {TabsContent} from './screens/TabsContent';
import {ContinueOnboardingPopover, WelcomeDialog} from './components/Dialogs';
import {OnboardingCtx} from './Onboarding.context';
import {getOnboardingState} from '../OnboardingDialog/service/completionState';
import {sendMonitor} from '../../utils/monitoring';
import styles from './styles.module.scss';

type Props = {isOpen?: boolean};

export const Onboarding = forwardRef((props: Props, ref) => {
    const {
        OB_is_open,
        OB_dialog_type,
        open_OB_dialog,
        close_OB_dialog,
        OB_process_start,
        open_skip_OB_alert
    } = useContext(OnboardingCtx);

    useImperativeHandle(
        ref,
        () => ({
            showOnboardingDlg: open_OB_dialog,
            closeOnboardingDlg: close_OB_dialog,
            isOnboardingDlgOpen: OB_is_open
        }),
        [OB_is_open, open_OB_dialog, close_OB_dialog]
    );

    const onCloseWizard = () => {
        const stepIndex = getOnboardingState().OB_step;
        let monitorText = 'OnboardingTabs';
        switch (stepIndex) {
            case '0':
                monitorText += 'CompanyX';
                break;
            case '1':
                monitorText += 'BankX';
                break;
            case '2':
                monitorText += 'QuestionsX';
                break;
            case '3':
                monitorText += 'SummaryX';
                break;
            default:
                return close_OB_dialog();
        }
        sendMonitor(monitorText);
        close_OB_dialog();
    };

    const onCloseContinueDialog = () => {
        sendMonitor('OnboardingContinueX');
        close_OB_dialog();
    };

    if (OB_dialog_type === ModalTypes.welcomeMsg) {
        return (
            <WelcomeDialog
                componentClasses={styles.welcomeModal}
                onClose={close_OB_dialog}
                startProcess={OB_process_start}
                showSkipDialog={open_skip_OB_alert}
                isOpen={OB_is_open}
            />
        );
    } else if (OB_dialog_type === ModalTypes.wizardSetup) {
        return (
            <Dialog
                size="large"
                width={980}
                isOpen={OB_is_open}
                onClose={onCloseWizard}
                componentClasses={styles.onboardingModal}
                content={<TabsContent onClose={close_OB_dialog} />}
            />
        );
    } else if (OB_dialog_type === ModalTypes.continueMsg) {
        return (
            <ContinueOnboardingPopover
                isOpen={OB_is_open}
                onClose={onCloseContinueDialog}
                startOnboarding={OB_process_start}
                showSkipDialog={open_skip_OB_alert}
            />
        );
    }

    return null;
});
